<template>
    <div class="table-of-contents">
        <div :class="['table-of-contents__header', {'not-logged': disabled}]">
            <span :class="'icon-' + headerIcon" v-if="headerIcon"></span>
            <div class="table-of-contents__header-content">
                <span>{{ header }}</span>
                <div class="table-of-contents__total-duration" v-if="courseTotalDuration">
                    <span class="icon-clock"></span>
                    <span class="table-of-contents__total-duration">{{ convertMinutesToHours(courseTotalDuration) }}</span>
                </div>
            </div>
        </div>
        <slot />
    </div>
</template>

<script>
    import convertMinutesToHours from 'components/shared/mixins/convertMinutesToHours'

    export default {
        name: 'table-of-contents',
        mixins: [convertMinutesToHours],
        props: {
            header: String,
            headerIcon: String,
            disabled: {
                type: Boolean,
                default: false
            },
            shouldScrollOnInit: Boolean,
            courseTotalDuration: {
                type: Number,
                default: 0
            }
        },
        methods: {
            switchToMicroLearningOverView () {
                if (!this.disabled) {
                    this.$store.dispatch('MicroLearning/assignMicroLearningSection', null)
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .table-of-contents {
        background-color: $white;
        width: 300px;
        border-radius: 20px 20px 0 0;

        [class*="desktop_xxxl"] & {
            width: 370px;
        }
        [class*="mobile"] & {
            width: 100%;
            margin: 30px 0 0 0;
        }

        &__header {
            font-size: 2rem;
            font-family: PPAgrandir-Medium, sans-serif;
            display: flex;
            align-items: center;
            position: relative;
            color: $stratos;
            padding: 24px 16px 14px;
            border-radius: 20px 20px 0 0;
        }

        [class*="icon-"] {
            font-size: 2rem;
            margin: 0 10px 0 0
        }

        .icon-info {
            margin-left: auto;
        }

        &__header-content {
            display: flex;
            gap: 6px;
            align-items: center;
            flex-wrap: wrap;
        }

        &__total-duration {
            font-size: 1.6rem;
            color: $lavender;

            .icon-clock {
                font-size: 1.6rem;
                margin: 0 5px 0 0;
            }
        }
    }
</style>
